<template>
    <div class='priceplans-duplicate'>
      <dean-two-column-layout title="Prijsplan dupliceren">
        <dean-section-title-item
            :icon="saveIcon"
            slot="title-items"
            :content="true"
            :large="true"
            @click.native="save"
        >
          Opslaan
        </dean-section-title-item>
        <div class="column" slot="left">
          <dean-form-row id="name" label="naam" v-model="data.name" type="text"
                         :required-field="true" :warning="$v.data.name.$error" @focus="$v.data.name.$touch()"/>
          <dean-select-form-row id="pricePlan" label="te dupliceren prijsplan" placeholder="kies een prijsplan"
                                :value="currentlySelectedPricePlan(data.pricePlan)" :options="pricePlans" @input="data.pricePlan = $event.value"
                                :required-field="true" :warning="$v.data.pricePlan.$error" @focus="$v.data.pricePlan.$touch()"/>
        </div>
      </dean-two-column-layout>
    </div>
</template>

<script lang="ts">
  import {Vue, Component} from 'vue-property-decorator';
  import {
    deanSectionTitleItem,
    saveIcon,
  } from '@deanone/dean-components';
  import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import DeanSelectFormRow from '../../../components/deanComponents/deanSelectFormRow.vue';
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';

  @Component({
    components: {
      DeanSelectFormRow,
      deanSectionTitleItem,
      DeanFormRow,
      DeanTwoColumnLayout,
    },
    mixins: [validationMixin],
  })
  export default class Duplicate extends Vue {
    // DATA
    public data: any = {
      name: null,
      pricePlan: null,
    };
    public pricePlans: Array<{[key: string]: string}> = [];
    public saveIcon: any = saveIcon;

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          name: {required},
          pricePlan: {required},
        },
      };
    }

    // METHODS
    public currentlySelectedPricePlan(value: any) {
      if (value !== null) {
        const foundKey = Number(Object.keys(this.pricePlans).find((key) => this.pricePlans[Number(key)].value === value));

        return foundKey != null ? this.pricePlans[foundKey] : null;
      }

      return null;
    }

    public save() {
      this.$v.$touch();

      if (! this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        this.$store.dispatch('processPricePlanDuplicate', {
          name: this.data.name,
          id: this.data.pricePlan,
        }).then(
          (response) => {
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public created() {
      this.$store.dispatch('setLoadOverlay', true);

      this.$store.dispatch('requestPricePlans', {
        pageNumber: 1,
        itemsPerPage: 100,
        sort: null,
      })
        .then(
          (response) => {
            this.pricePlans = response.data.data.map((pricePlan: any) => {
              return {
                value: pricePlan.id,
                label: pricePlan.name ? pricePlan.name : '',
              };
            });
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
    }
  }
</script>

<style lang="scss" scoped>

</style>
